import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { SessionService } from "../../shared/services/session.service";
import { UserService } from "../../user/user.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): true | UrlTree | Observable<boolean | UrlTree> {
    // if already connected, we redirect to the default page
    if (this.sessionService.isLoggedIn()) {
      console.log("LoginGuard: user is already logged in, redirecting to default page");
      return this.userService.defaultPage().pipe(
        map((pageName) => {
          return this.router.createUrlTree([pageName]);
        }),
        catchError(() => {
          return of(true);
        })
      );
    }
    return true;
  }
}
